import 'dayjs/locale/zh-cn';
import React from 'react';

import { useTranslations } from '@/translations/useTranslations.js';

const HomePage = () => {
    const { t } = useTranslations();

    return (
        <>
            <div>
                <div className="lg_title">{t('label.home')}</div>
                <div className="lg_desc">{t('dummy')}</div>
            </div>
            {}
            {}
        </>
    );
};

export default HomePage;
